import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { CoreDataService } from '../core.data';
import { CustomEncoder } from '../http.util';
import { Observable } from 'rxjs';
import { ConfigResponse } from '@app/core/services/version-config';

@Injectable({
  providedIn: 'root',
})
export class ConfigHttpService {
  constructor(private _coreDataService: CoreDataService) {}

  getApiVersionConfigurations(version: string): Observable<ConfigResponse> {
    const headers = new HttpHeaders();
    const options = {
      headers,
      withCredentials: false,
      params: null,
    };

    options.params = this._coreDataService.generatePlatformQueryParameters(
      new HttpParams({
        encoder: new CustomEncoder(),
      }),
      { version },
    );
    return this._coreDataService.get<ConfigResponse>(`static/config`, options);
  }
}
